module.exports = __webpack_public_path__ + "static/media/YF97_4.c7d99a50.jpg";